import { eInvoiceCountryConfig, EInvoiceCountryConfig } from '../constants/eInvoiceCountryConfig'

export const getEInvoiceCountryConfig = (countryId: string | undefined): EInvoiceCountryConfig | undefined =>
  countryId ? eInvoiceCountryConfig[countryId] : undefined
